const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

export default function stationPinLetter(index) {
  return letters[index];
}
